/**
 * Códigos de erro de TICKET que atravessam back → front.
 * Padrão: ERR_<DOMÍNIO>_<MOTIVO>.
 */
export const TICKET_ERRORS = {
  /**
   * 400 — filtro do relatório de tickets fora do formato esperado (#4479).
   * Data tem de ser AAAA-MM-DD. Antes a entrada ia crua para a SQL; agora é
   * recusada na entrada, em vez de virar erro de tipo do banco.
   */
  REPORT_INVALID_FILTER: "ERR_TICKET_REPORT_INVALID_FILTER",

  /**
   * 400 — tentou abrir atendimento de GRUPO numa conexão que não aceita
   * grupos (#4453). Esconder o contato no "Novo Ticket" não basta: a rota
   * continuava aceitando, o ticket nascia e a mensagem não chegava a lugar
   * nenhum — o cliente reportava como "enviei e não recebeu".
   */
  GROUP_NOT_ALLOWED: "ERR_TICKET_GROUP_NOT_ALLOWED",

  /**
   * 403 — o usuário não tem acesso à CONEXÃO deste atendimento (#4271).
   *
   * Esconder o ticket da listagem não basta: quem souber o id ou o uuid abre
   * pela URL e lê a conversa inteira. A recusa fecha a porta de entrada.
   */
  CONNECTION_NOT_ALLOWED: "ERR_TICKET_CONNECTION_NOT_ALLOWED",
} as const;

export type TicketErrorCode = (typeof TICKET_ERRORS)[keyof typeof TICKET_ERRORS];
